import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useInvoiceTaskActivities } from '@/hooks/api/1940_invoice_task_activities';
import { ActivityRow } from '@/components/features/ActivityRow';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useParams } from 'react-router-dom';

export const Activities = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { invoiceTask: task } = useCurrentInvoiceTask();
  const { data: activities } = useInvoiceTaskActivities({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    sales_order_id: Number(sales_order_id),
    task_id: task!.id,
  });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">タスクの変更履歴</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="timeline timeline-one-side" data-timeline-axis-style="dotted">
          {activities?.map((d) => <ActivityRow key={`activity-${d.id}`} d={d} />)}
        </div>
      </div>
    </MotionDiv>
  );
};
